import { createContext } from "react";

export const AchievementModalContext = createContext();
